var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPrimarySmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.293%",
    y1: "0%",
    x2: "88.829%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.614%",
    y1: "26.741%",
    x2: "63.464%",
    y2: "84.168%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ACCDD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FB0AE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "18.44%",
    x2: "50%",
    y2: "90.687%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FEADF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BEBA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.208%",
    y1: "44.167%",
    x2: "49.095%",
    y2: "72.947%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FEADF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BEBA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.3%",
    y: "-17.2%",
    width: "144.6%",
    height: "129.3%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.166926457 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.574 23.251c-4.995-6.615-9.083-13.145-6.854-11.762 3.482 2.162 28.662 5.305 36.112 33.652 7.45 28.347-14.192 42.362-20.932 43.65-.739.142-1.934.516-3.547.754-.591.088-1.604.173-3.04.255l.025-.061c-4.071.12-9.388-1.387-12.538-3.606-8.322-5.864-11.448-13.846-9.38-23.945h13.586C48.4 67.538 49.066 72.222 53 76.242c2.137 2.183 5.627 3.5 9.8 2.763 2.184-.386 4.307-1.628 6.371-3.726l-.005.029c4.368-5.827 6.019-11.516 6.533-17.104.812-8.829-3.077-18.485-9.8-25.102-2.151-2.117-4.837-5.314-7.38-8.611l-.475-.62z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.25 0c6.63 4.64 11.736 9.53 15.32 14.668C76.35 20.922 88.3 37.091 88.3 56.05c0 24.383-19.767 44.15-44.15 44.15S0 80.433 0 56.05c0-18.99 11.989-35.179 28.81-41.412C32.426 9.51 37.573 4.63 44.25 0zm21.643 33.189.004.2.003.461c0 12.463-7.217 23.747-21.65 33.85C29.683 57.597 22.4 46.313 22.4 33.85c0-.22.002-.44.007-.66-6.041 5.746-9.807 13.863-9.807 22.86 0 17.425 14.125 31.55 31.55 31.55S75.7 73.475 75.7 56.05c0-8.997-3.766-17.114-9.807-22.861z",
    fill: "url(#a)",
    transform: "translate(16.3 9.9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.3 9.9)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 67.7C58.683 57.597 65.9 46.313 65.9 33.85c0-12.463-7.217-23.747-21.65-33.85C29.683 10.103 22.4 21.387 22.4 33.85c0 12.463 7.283 23.747 21.85 33.85z",
    fill: "url(#e)",
    transform: "translate(16.3 9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 67.7V0C29.683 10.103 22.4 21.387 22.4 33.85c0 12.463 7.283 23.747 21.85 33.85z",
    fill: "url(#f)",
    transform: "translate(16.3 9.9)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimarySmall);
export default __webpack_public_path__ + "static/media/logo-primary-small.aed34861f8cc3aeb7f21a978a7b4fc83.svg";
export { ForwardRef as ReactComponent };